import { render, staticRenderFns } from "./templateEn.html?vue&type=template&id=ee72abb8&scoped=true&"
import script from "./HomeSNSEn.vue?vue&type=script&lang=ts&"
export * from "./HomeSNSEn.vue?vue&type=script&lang=ts&"
import style0 from "./HomeSNSEn.vue?vue&type=style&index=0&id=ee72abb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee72abb8",
  null
  
)

export default component.exports